import { Factory } from "@/data/dao/Factory";
import { type IOfflineStorage, OfflineStorage } from "@/data/dao/offline/OfflineStorage";
import { config } from "@/data/util/Config";

export class AuthTokenService {
    private offlineStorage: IOfflineStorage;

    constructor() {
        this.offlineStorage = Factory.getInstance<IOfflineStorage>(OfflineStorage);
    }

    public getBearer(): string | undefined {
        const bearer = this.offlineStorage.readString(config.tokenCookieName);
        return bearer ?? undefined;
    }

    public setBearer(bearer: string) {
        if (bearer == null) {
            this.offlineStorage.remove(config.tokenCookieName);
        } else {
            this.offlineStorage.writeString(config.tokenCookieName, bearer);
        }
    }

    public resetBearer() {
        this.offlineStorage.remove(config.tokenCookieName);
    }

    public static getClassName(): string {
        return "AuthTokenService";
    }
}
